'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createQueryMiddleware;

var _createLocationMiddleware = require('./createLocationMiddleware');

var _createLocationMiddleware2 = _interopRequireDefault(_createLocationMiddleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createQueryMiddleware(_ref) {
  var parse = _ref.parse,
      stringify = _ref.stringify;

  return (0, _createLocationMiddleware2.default)({
    makeLocationDescriptor: function makeLocationDescriptor(location) {
      var query = location.query;

      if (query === undefined) {
        return location;
      }

      var queryString = stringify(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, location, { search: search });
    },
    makeLocation: function makeLocation(location) {
      if (location.query !== undefined) {
        return location;
      }

      var query = void 0;
      try {
        query = parse(location.search.slice(1));
      } catch (e) {
        query = null;
      }

      return _extends({}, location, { query: query });
    }
  });
}
module.exports = exports['default'];


// WEBPACK FOOTER //
// ./~/farce/lib/createQueryMiddleware.js